import { all } from "redux-saga/effects";

import productSaga from "./sagas/product";
import userSaga from "./sagas/user";
import cartSaga from "./sagas/cart";
import orderSaga from "./sagas/order";
import pagesSaga from "./sagas/page";

export default function* rootSaga() {
  yield all([productSaga(), userSaga(), cartSaga(), orderSaga(), pagesSaga()]);
}
